<template>
  <v-dialog v-model="dialogModel" max-width="500" persistent>
    <v-card class="rounded-xl">
      <v-card-title class="d-flex align-center pb-0">
        <v-icon color="#10B981" class="mr-2">mdi-check-circle-outline</v-icon>
        <span class="dialog-title">อนุมัติร้านค้า</span>
        <v-spacer />
        <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>

      <v-divider class="mx-4 mt-2" />

      <v-card-text class="pt-4">
        <div v-if="seller" class="seller-info mb-2">
          <div class="d-flex align-center mb-2">
            <v-icon small class="mr-2">mdi-store-outline</v-icon>
            <span class="font-weight-medium">{{ seller.shopName || '-' }}</span>
          </div>
          <div class="d-flex align-center mb-2">
            <v-icon small class="mr-2">mdi-account</v-icon>
            <span>{{ sellerDisplayName }}</span>
          </div>
          <div class="d-flex align-center">
            <v-icon small class="mr-2">mdi-email-outline</v-icon>
            <span>{{ seller.email || '-' }}</span>
          </div>
        </div>
        <div class="body-2 grey--text mt-3">ยืนยันการอนุมัติร้านค้านี้? ผู้ขายจะสามารถเข้าสู่ระบบและจัดการร้านค้าได้ทันที</div>
      </v-card-text>

      <v-divider class="mx-4" />

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text class="rounded-lg" @click="close">ยกเลิก</v-btn>
        <v-btn
          color="#10B981"
          dark
          class="rounded-lg elevation-0 px-6"
          :loading="saving"
          @click="$emit('confirm')"
        >
          <v-icon left small>mdi-check</v-icon>
          ยืนยันอนุมัติ
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SellerApproveDialog",

  props: {
    value: Boolean,
    seller: { type: Object, default: null },
    saving: Boolean,
  },

  computed: {
    dialogModel: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); },
    },

    sellerDisplayName() {
      if (!this.seller) return "-";
      const p = this.seller.natId_prefix || "";
      const f = this.seller.natId_firstName || "";
      const l = this.seller.natId_lastName || "";
      const parts = [p, f, l].filter(Boolean);
      return parts.length ? parts.join(" ") : this.seller.username || "-";
    },
  },

  methods: {
    close() {
      this.dialogModel = false;
    },
  },
};
</script>

<style scoped>
.dialog-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2a39;
}
.seller-info {
  background: #f9fafb;
  border-radius: 8px;
  padding: 12px 16px;
}
</style>
